<div #toggleElement [ngClass]="!disabled ? 'se-ui-datagrid-boolean_box_editor' : 'se-ui-datagrid-boolean_box_overlay'">
    <mat-checkbox *ngIf="editor ==='CHECKBOX'"
                class="se-ui-datagrid-boolean_box"
                [ngClass]="{'se-ui-datagrid-boolean_box_renderer_index' : disabled}"
                tabindex="0"
                [ngModel]="checked"
                (ngModelChange)="_onChange($event)"
                [disabled]="disabled"
                [color]="color">
    </mat-checkbox>
    <mat-slide-toggle *ngIf="editor ==='SLIDETOGGLE'"
                class="se-ui-datagrid-boolean_box"
                [ngClass]="{'se-ui-datagrid-boolean_box_renderer_index' : disabled}"
                tabindex="0"
                [ngModel]="checked"
                (ngModelChange)="_onChange($event)"
                [disabled]="disabled"
                [color]="color">
    </mat-slide-toggle>
</div>
<!-- Validazione -->
<span *ngIf="formGroup" [formGroup]="formGroup">
    <input type="hidden"
           [formControlName]="key"
           [id]="key">
</span>
<!-- Fine Validazione -->
